import { Navigate, Route } from "react-router-dom";
import FirewallWhitelist from '../modules/system/firewall/views/FirewallWhitelist';
import NotificationRulesPage from '../modules/system/settings/views/NotificationRulesPage';
import PBXServerList from '../modules/system/servers/views/PBXServerList';
import PBXServerIssuesPage from '../modules/system/servers/views/PBXServerIssuesPage';
import WaInstanceList from '../modules/system/wainstances/views/WaInstanceList';
import MobileAppsView from '../modules/system/mobileapps/views/MobileAppsView';
import AnnouncementsList from '../modules/system/announcements/views/AnnouncementsList';
import PreferencesMainView from "../modules/system/settings/views/PreferencesMainView";
import AccountOverview from '../modules/system/settings/views/AccountOverview';
import AccountSecurity from '../modules/system/settings/components/AccountSecurity';
import SubscriptionView from '../modules/system/settings/views/SubscriptionView';
import AccountWallet from '../modules/system/settings/components/AccountWallet';
import InvoicesList from '../modules/system/settings/views/InvoicesList';
import CompanySettings from '../modules/system/settings/components/CompanySettings';
import NotificationsView from '../modules/system/settings/views/NotificationsView';
import OtherSettingsView from '../modules/system/settings/views/OtherSettingsView';
import LoginSettings from '../modules/profile/components/preferences/LoginSettings';
import MessagesUsage from '../modules/system/settings/components/usage/MessagesUsage';
import CallsUsage from '../modules/system/settings/components/usage/CallsUsage';
import CouponsList from '../modules/system/coupons/views/CouponsList';
import {
    EditAccountPage,
    EditOwnerPage,
    PaymentMethodsPage,
    IntegrationsPage,
    NotificationHistoryPage,
    PreferencesPage,
} from "../modules/system/settings/views/PreferencesPages";


function SystemRoutes() {
    let k = 0;
    return (
        [
            <Route key={k++} path="/system" element={<PreferencesMainView />}>
                <Route path="account/overview" element={<AccountOverview />} />
                <Route path="account/edit-account" element={<EditAccountPage />} />
                <Route path="account/security" element={<AccountSecurity />} />
                <Route path="account/edit-owner" element={<EditOwnerPage />} />
                <Route path="account/company" element={<CompanySettings />} />
                <Route path="finance/subscription" element={<SubscriptionView />} />
                <Route path="finance/payment-methods" element={<PaymentMethodsPage />} />
                <Route path="finance/wallet" element={<AccountWallet />} />
                <Route path="finance/invoices" element={<InvoicesList />} />
                <Route path="usages/messages" element={<MessagesUsage />} />
                <Route path="usages/calls" element={<CallsUsage />} />
                <Route path="announcements" element={<AnnouncementsList />} />
                <Route path="firewall/whitelist" element={<FirewallWhitelist />} />
                <Route path="general/integrations" element={<IntegrationsPage />} />
                <Route path="account/preferences" element={<PreferencesPage />} />
                <Route path="account/notifications" element={<NotificationsView />} />
                <Route path="account/notification-history" element={<NotificationHistoryPage />} />
                <Route path="account/login-rules" element={<LoginSettings />} />
                <Route path="general/notifications" element={<Navigate to="/system/account/notifications" replace />} />
                <Route path="general/others" element={<OtherSettingsView />} />
                <Route path="general/coupons" element={<CouponsList />} />
                <Route path="servers" element={<PBXServerList />} />
                <Route path="wainstances" element={<WaInstanceList />} />
                <Route path="mobileapps" element={<MobileAppsView />} />
            </Route>,

            <Route key={k++} path="/system/notifications/rules" element={<NotificationRulesPage />} />,

            <Route key={k++} path="/system/servers/issues/:selectedId" element={<PBXServerIssuesPage />} />,

        ]
    );
}

export default SystemRoutes;
